// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Book } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu'; 

// icons
const icons = { Book };

// ==============================|| MENU ITEMS - category ||============================== //

const PackageHistory: NavItemType = {
    id: 'Packagehistory',
    //   title: <FormattedMessage id="Add Organization" />,
    type: 'group',
    //   name: 'Add Organization',
    icon: icons.Book,
    children: [
        {
            icon: icons.Book,
            id: 'Packagehistory',
            title: <FormattedMessage id="Package History" />,
            type: 'item',
            url: '/superadmin/package/history'
        }
    ]
};

export default PackageHistory;
